// useSnackbarHelper.tsx
import { MIconButton } from '@/components/@material-extend';
import closeFill from '@iconify/icons-eva/close-fill';
import { Icon } from '@iconify/react';
import { OptionsObject, SnackbarKey, SnackbarMessage, useSnackbar, VariantType } from 'notistack';
import { useCallback } from 'react';

interface SnackbarHelper {
    showSnackbar: (message: SnackbarMessage, variant: VariantType) => void;
}

export const useSnackbarHelper = (): SnackbarHelper => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const showSnackbar = useCallback(
        (message: SnackbarMessage, variant: VariantType): void => {
            const action = (key: SnackbarKey): JSX.Element => (
                <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                    <Icon icon={closeFill} />
                </MIconButton>
            );
            const options: OptionsObject = {
                variant,
                action
            };
            enqueueSnackbar(message, options);
        },
        [enqueueSnackbar, closeSnackbar]
    );
    return { showSnackbar };
};
